<template>
  <div class="d-flex justify-content-center">
    <div>
      <form @submit.prevent="submitForm" class="text-center">
        <div class="form-group">
          <label for="email">Email address</label>
          <input
            type="text"
            class="form-control mx-auto"
            style="max-width: 300px"
            id="email"
            v-model="formData.email"
            placeholder="Enter email"
            @change="checkExistingUser"
            required
          />
        </div>
        <div class="form-group">
          <label for="assessmentCode">Assessment Code</label>
          <input
            type="text"
            class="form-control mx-auto"
            id="assessmentCode"
            v-model="formData.assessmentCode"
            placeholder="Assessment Code"
            required
          />
        </div>
        <div class="form-group">
          <label for="password"><span v-if="!accountExists">Create </span>Password</label>
          <input
            type="password"
            class="form-control mx-auto"
            id="password"
            v-model="formData.password"
            placeholder="Password"
            required
          />
        </div>
        <div v-if="accountExists">
          <p class="alert alert-success">User account exists!</p>
        </div>
        <div class="form-group">
          <label for="firstName" v-if="!accountExists">First Name</label>
          <input
            type="text"
            class="form-control mx-auto"
            id="firstName"
            v-model="formData.firstName"
            placeholder="First Name"
            v-if="!accountExists"
            required
          />
        </div>
        <div class="form-group">
          <label for="lastName" v-if="!accountExists">Last Name</label>
          <input
            type="text"
            class="form-control mx-auto"
            id="lastName"
            v-model="formData.lastName"
            placeholder="Last Name"
            v-if="!accountExists"
            required
          />
        </div>
        <div class="form-group">
          <label for="phone" v-if="!accountExists">Phone Number</label>
          <input
            type="text"
            class="form-control mx-auto"
            style="max-width: 300px"
            id="phone"
            v-model="formattedPhoneNumber"
            placeholder="Phone Number"
            v-if="!accountExists"
            required
          />
        </div>
        <button type="submit" class="btn btn-primary submit-button">
          <span v-if="!accountExists">Create Account & </span>Start Assessment
        </button>
      </form>
    </div>
  </div>
  <DialogModal :error-message="errorMessage" :error-title="errorTitle" :info-class="infoClass" ref="dialogModal" />
</template>

<script>
import { endpoint } from '@/utils/endpoint/endpointUtils';
import DialogModal from '@/components/DialogModal.vue';
import { setCookie } from '@/utils/cookies/cookieUtils';

export default {
  emits: ['assessment-started'],
  components: {
    DialogModal
  },
  data() {
    return {
      formData: {
        email: '',
        assessmentCode: '',
        password: '',
        firstName: '',
        lastName: '',
        phone: ''
    },
    rawPhoneNumber: '',
    errorTitle: 'Assessment Lookup',
    errorMessage: 'No assessment was found with the email and assessment code provided. Please check with your recruiter or potential employer.',
    infoClass: 'alert alert-warning',
    accountExists: false
  };
},
methods: {
  async startAssessment(assessmentId, userId, numberOfQuestions, timeLimit, token) {
    setCookie('assessmentId', assessmentId);
    setCookie('userid', userId);
    setCookie('numberOfQuestions', numberOfQuestions);
    setCookie('limit', timeLimit);
    setCookie('token', token);
    
    // Tell the view that the assessment is started.
    this.$emit('assessment-started');
  },
  async noAssessmentFound() {
    console.log('No assessment found here!');
    console.log("trying to show dialog");
    this.$refs.dialogModal.openModal();
  },
  async submitForm() {
    await this.verifyAssessment();
  },
async verifyAssessment() {
  const body = {
    email: this.formData.email,
    guid: this.formData.assessmentCode,
    password: this.formData.password,
    firstname: this.formData.firstName,
    lastname: this.formData.lastName,
    phone: this.formData.phone
  };
  try {
    const response = await fetch(endpoint + '/api/Assessments/VerifyAssessment', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
          });

          if (!response.ok) {
            //throw new Error(`HTTP error! status: ${response.status}`);
            await this.noAssessmentFound();
          }

          const data = await response.json();
          if (data.message === 'Success') {
            await this.startAssessment(data.assessmentId, 
                                       data.userId, 
                                       data.numberOfQuestions, 
                                       data.timeLimit, data.token);
          } else {
            await this.noAssessmentFound();
          }
        } catch(error) {
          console.log(error);
        }
      },
      async checkExistingUser() {
        const body = {
          email: this.formData.email
        };
        try {
          const response = await fetch(endpoint + '/api/User/UserExistsByEmail', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          if (data.exists === true) {
            this.accountExists = true;
            //setCookie('token', data.token);
          } else {
            this.accountExists = false;
          }
        } catch(error) {
          console.log(error);
        }
      },
      formatPhoneNumber() {
          // Remove any characters that are not digits
          let numbers = this.formattedPhoneNumber.replace(/\D/g, '');

          // Trim the number to 10 digits max
          numbers = numbers.substring(0, 10);

          // Split the number into parts and join with dashes
          const parts = [];
          if (numbers.length > 3) {
              parts.push(numbers.substring(0, 3));
              if (numbers.length > 3 && numbers.length <= 6) {
              parts.push(numbers.substring(3, 6));
              } else if (numbers.length > 6) {
              parts.push(numbers.substring(3, 6));
              parts.push(numbers.substring(6, 10));
              }
          } else {
              parts.push(numbers);
          }

          // Update the raw phone number for internal use if necessary
          this.rawPhoneNumber = numbers;

          // Update the formatted phone number
          this.formattedPhoneNumber = parts.join('-');
      },
  },
  computed: {
    formattedPhoneNumber: {
      get() {
        // When the component needs the value, return the formatted version
        const parts = [];
        if (this.rawPhoneNumber.length > 3) {
          parts.push(this.rawPhoneNumber.substring(0, 3));
          if (this.rawPhoneNumber.length > 3 && this.rawPhoneNumber.length <= 6) {
            parts.push(this.rawPhoneNumber.substring(3, 6));
          } else if (this.rawPhoneNumber.length > 6) {
            parts.push(this.rawPhoneNumber.substring(3, 6));
            parts.push(this.rawPhoneNumber.substring(6, 10));
          }
        } else {
          parts.push(this.rawPhoneNumber);
        }
        return parts.join('-');
      },
      set(newValue) {
        // When the user types, strip non-numeric characters and update rawPhoneNumber
        this.rawPhoneNumber = newValue.replace(/\D/g, '');
      }
    }
  }
}
</script>

<style scoped>
/* Add your component-specific styles here */
.submit-button {
  width: 300px;
  padding: 10px;
  background-color: #382d61;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #72018f;
}

input[type="text"],
input[type="password"] input[type="tel"] input[type="email"] {
  width: 300px;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  border-color: rgb(62, 68, 70);
  background-color: #4f4f4f;
  color: cornsilk;
}

input::placeholder {
  color: #7e7e7e; /* Light grey placeholder text */
}

input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #7e7e7e;
}

input::-moz-placeholder {
  /* Firefox 19+ */
  color: #7e7e7e;
  opacity: 1; /* Firefox has a lower opacity on placeholder by default */
}

input:-ms-input-placeholder {
  /* IE 10+ */
  color: #7e7e7e;
}

input:-moz-placeholder {
  /* Firefox 18- */
  color: #7e7e7e;
}
</style>
